import base from '../../../common/base';
export default {
  setPriorityShipMutations(state, payload) {
    const priorityShipItems = [];
    if (payload) {
      payload.map((item) => {
        priorityShipItems.push(item);
      });
    }
    state.csvFlag = false;
    state.priorityShipItems = priorityShipItems;
  },
  updatePriorityShipMutations(state, payload) {
    state.csvFlag = false;
    state.priorityShipItems = state.priorityShipItems.map((item) => {
      const res = payload.find((i) => i.member_id === item.member_id && i.issue_date === item.issue_date);
      return Object.assign({}, item, res);
    });
  },
  clearPriorityShipDataMutations(state) {
    state.priorityShipItems = [];
    state.csvFlag = false;
  },
  setIssueDateWeekPulldownMutations(state, payload) {
    const issueDateWeekPulldownItem = [];
    if (payload) {
      payload.map((item) => {
        issueDateWeekPulldownItem.push({
          value: base.getFormatDate(item.from_date) + ' ~ ' + base.getFormatDate(item.to_date),
        });
      });
    }
    state.issueDateWeekPulldownItem = issueDateWeekPulldownItem;
  },
  priorityShipCsvImportMutations(state, payload) {
    const priorityShipItems = [];
    state.priorityShipItems = [];
    payload.map((item) => {
      priorityShipItems.push({
        issue_date: item[0],
        member_id: item[1],
        member_name_en: item[2],
        base_id: item[3],
        matter_no_csv: item[4],
        total_quantity: item[5] ? item[5] : 0,
        total_weight: item[6] ? item[6] : 0,
        priority: item[7],
      });
    });
    state.csvFlag = true;
    state.priorityShipItems = priorityShipItems;
  },
};
